// extracted by mini-css-extract-plugin
export default {"page":"p1-z","cartModal":"q1-z","checkout":"r1-z","placeholder":"s1-z","account":"t1-z"};